import { Suspense, lazy } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import Spinner from 'src/components/common/spinner'
import { APP_ENV } from 'src/env'

import ErrorBoundary from './errorBoundary'

const RequestEmailPage = lazy(() => import('./requestEmail'))

const RequestEmailContainer = (props) => (
    <div className="h-full w-full">
        <Suspense fallback={<Spinner />}>
            <GoogleReCaptchaProvider
                reCaptchaKey={APP_ENV.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
            >
                <ErrorBoundary>
                    <RequestEmailPage {...props} />
                </ErrorBoundary>
            </GoogleReCaptchaProvider>
        </Suspense>
    </div>
)

export default RequestEmailContainer
